import React, { ReactNode } from 'react';
import { BackIcon } from '../BackButton';

import * as S from './styles';

export type HeadTitleProps = {
  title: string;
  disableBack?: boolean;
  goBack?: () => void;
};

const HeadTitle: React.FC<HeadTitleProps> = ({ title, disableBack, goBack, ...rest }) => {
  return (
    <S.Container {...rest}>
      {!disableBack && <BackIcon goBack={goBack} />}
      <S.Head>{title}</S.Head>
    </S.Container>
  );
};

export default HeadTitle;
